import { Instagram, Facebook, Mail, Phone } from 'lucide-react';


const Footer = () => {
  return (
    <footer className="bg-forest-green text-earthy-sand py-12 px-6">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-8">
        <div
          onClick={() => document.getElementById('bio')?.scrollIntoView({ behavior: 'smooth' })}
          className="text-center lg:text-left cursor-pointer hover:opacity-80 transition-opacity interactive shrink-0"
        >
          <h3 className="font-serif text-2xl mb-1">Amelia Downie</h3>
          <p className="text-sm opacity-80">Land Healing Practitioner</p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4">
          <a href="https://www.instagram.com/ameliadownie.land?igsh=YWNjZHlwbjdrbmE2&utm_source=qr" target="_blank" rel="noopener noreferrer" className="hover:text-sage-mist transition-colors interactive flex space-x-2 items-center">
            <Instagram className='w-5 h-5' />
            <p className='text-base opacity-80'>Instagram</p>
          </a>
          <a href="https://www.facebook.com/share/17YE7tjZWG/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="hover:text-sage-mist transition-colors interactive flex space-x-2 items-center">
            <Facebook className='w-5 h-5' />
            <p className='text-base opacity-80'>Facebook</p>
          </a>
          <span className="hover:text-sage-mist transition-colors cursor-pointer interactive flex space-x-2 items-center whitespace-nowrap">
            <Phone className='w-5 h-5' />
            <p className='text-base opacity-80'>+61 438 313 730</p>
          </span>
          <span className="hover:text-sage-mist transition-colors cursor-pointer interactive flex space-x-2 items-center whitespace-nowrap">
            <Mail className='w-5 h-5' />
            <p className='text-base opacity-80'>a@ameliadownie.com.au</p>
          </span>
        </div>

        <div className="text-xs opacity-60 text-center lg:text-right shrink-0">
          © {new Date().getFullYear()} Amelia Downie Land Healing.<br className="md:hidden" /> All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
